import React from 'react';
import {connect} from 'react-redux';
import {
  mapRefDataCode,
  phoneTypeProfileToContacts,
  displayObjectErrors,
} from 'common/utils';
import {createPrefixOptions} from 'go/components/organization/subOrganization/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Header, Form, Grid} from 'semantic-ui-react';
import {
  InlineTextBoxField,
  InlineSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {
  GRANT_WRITER_ROLE,
  AOR_ROLE,
  SAR_ROLE,
} from 'go/components/organization/team/constants';
import {Toggle} from 'componentLibrary';

export const phoneNumberOptions = [
  {key: 0, value: '', text: ''},
  {key: 1, value: 'home', text: 'Home'},
  {key: 2, value: 'work', text: 'Work'},
  {key: 3, value: 'mobile', text: 'Mobile'},
];

class ContactInfoModal extends React.Component {
  state = {
    retrievedOrgMembers: false,
    orgMembers: [],
    orgGrantWriters: [],
    orgAors: [],
    orgSars: [],
    refData: {
      salutationType: [],
    },
  };

  handleChange = (name, value) => {
    this.props.handleChange(name, value);
  };

  saveContactInfo = (fieldName) => {
    const {handleBlur} = this.props;
    handleBlur(fieldName);
  };

  componentDidMount() {
    REST.ref
      .getPrefixes()
      .then((res) => res.json())
      .then((resJson) => {
        let refData = {
          salutationType: mapRefDataCode(resJson.PREFIX),
        };
        this.setState({refData: refData});
      })
      .catch((error) => {
        console.error('error');
      });

    this.retrieveOrgMembers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.organizationId !== prevProps.organizationId) {
      this.retrieveOrgMembers();
    }
  }

  retrieveOrgMembers() {
    if (!this.state.retrievedOrgMembers && this.props.organizationId) {
      let parentOrgId = this.props.parentOrgId;

      // case to cover tribe organizations which can be parent and child
      if (this.props.canHaveSubOrg && parentOrgId !== this.props.organizationId) {
        parentOrgId = this.props.organizationId + ',' + this.props.parentOrgId;
      }

      REST.user
        .getPocListEntityByParentId(
          this.props.token,
          parentOrgId,
          this.props.organizationId,
          _.includes(this.props.toggles, 'manageTeamOrgSubOrg') // TODO, remove this toggle reference and cleanup toggle
        )
        .then(REST.handler.handleResponse)
        .then((result) => {
          const grantWriters = _.filter(
            result,
            (res) =>
              _.find(res.roles, (role) => role.roleId === GRANT_WRITER_ROLE) !== undefined
          );
          const aors = _.filter(
            result,
            (res) => _.find(res.roles, (role) => role.roleId === AOR_ROLE) !== undefined
          );
          const sars = _.filter(
            result,
            (res) => _.find(res.roles, (role) => role.roleId === SAR_ROLE) !== undefined
          );
          this.setState({
            retrievedOrgMembers: true,
            orgMembers: result,
            orgGrantWriters: grantWriters,
            orgAors: aors,
            orgSars: sars,
          });
        })
        .catch((err) => {
          console.log('err');
        });
    }
  }

  handleChoosingUser = (index) => {
    const {orgGrantWriters, orgMembers, orgAors, orgSars} = this.state;
    const manageTeamOrgSubOrgToggle = _.get(this.props, 'toggles', []).includes(
      'manageTeamOrgSubOrg'
    );
    const userAORorSAR = manageTeamOrgSubOrgToggle;

    const userToPrepopFrom = _.get(
      this.props.type == 'participants'
        ? orgGrantWriters
        : userAORorSAR
        ? this.props.type == 'sars'
          ? orgSars
          : orgMembers
        : this.props.type == 'aors'
        ? orgAors
        : orgMembers,
      index,
      {}
    );

    const phone = _.get(userToPrepopFrom, 'phoneNumbers', []);
    const primaryPhone = _.get(phone, 0, {});
    const secondaryPhone = _.get(phone, 1, {});
    const optionalPhone = _.get(phone, 2, {});

    const userToSave = {
      firstName: _.get(userToPrepopFrom, 'firstName', ''),
      lastName: _.get(userToPrepopFrom, 'lastName', ''),
      email:
        _.get(userToPrepopFrom, 'emailAdr', '') || _.get(userToPrepopFrom, 'userId', ''),
      phoneNumber:
        (_.get(primaryPhone, 'areaCd') ? _.toString(_.get(primaryPhone, 'areaCd')) : '') +
        (_.get(primaryPhone, 'phoneNumber')
          ? _.toString(_.get(primaryPhone, 'phoneNumber'))
          : ''),
      phoneNumberType: phoneTypeProfileToContacts(_.get(primaryPhone, 'phoneNumberType')),
      extension: _.get(primaryPhone, 'phoneExt'),
      secondaryPhoneNumber:
        (_.get(secondaryPhone, 'areaCd')
          ? _.toString(_.get(secondaryPhone, 'areaCd'))
          : '') +
        (_.get(secondaryPhone, 'phoneNumber')
          ? _.toString(_.get(secondaryPhone, 'phoneNumber'))
          : ''),
      secondaryPhoneExt: _.get(secondaryPhone, 'phoneExt'),
      secondaryPhoneType: phoneTypeProfileToContacts(
        _.get(secondaryPhone, 'phoneNumberType')
      ),
      optionalPhoneNumber:
        (_.get(optionalPhone, 'areaCd')
          ? _.toString(_.get(optionalPhone, 'areaCd'))
          : '') +
        (_.get(optionalPhone, 'phoneNumber')
          ? _.toString(_.get(optionalPhone, 'phoneNumber'))
          : ''),
      optionalPhoneExt: _.get(optionalPhone, 'phoneExt'),
      optionalPhoneType: phoneTypeProfileToContacts(
        _.get(optionalPhone, 'phoneNumberType')
      ),
      type: 'alternate',
    };
    this.props.handleChoose(userToSave);
    this.setState({
      selectedContact: index,
    });
  };

  render() {
    const {
      open,
      type,
      config,
      handleClose,
      handleDelete,
      validationDirtyMap,
      validationErrors,
      duplicatePointOfContactErrors,
      contact,
    } = this.props;
    const {
      orgGrantWriters,
      orgMembers,
      orgAors,
      orgSars,
      selectedContact = -1,
    } = this.state;

    const manageTeamOrgSubOrgToggle = _.get(this.props, 'toggles', []).includes(
      'manageTeamOrgSubOrg'
    );
    const userAORorSAR = manageTeamOrgSubOrgToggle;

    const salutationOpts = _.concat(
      {
        text: '',
        key: '',
        value: '',
      },
      createPrefixOptions(this.state.refData.salutationType)
    );

    const isParticipants = type === 'participants';
    const isPointOfContacts = type === 'pointOfContacts';
    const isAors = userAORorSAR ? type === 'sars' : type === 'aors';

    const dpOptions = isParticipants
      ? orgGrantWriters
      : isAors
      ? userAORorSAR
        ? orgSars
        : orgAors
      : orgMembers;
    let headerOptions = [
      {
        key: -2,
        value: -2,
        text: 'Select',
      },
      {
        key: -1,
        value: -1,
        text: isParticipants ? 'Other preparer' : isPointOfContacts ? 'New contact' : '',
      },
    ];
    if (isAors) _.remove(headerOptions, (item) => item.key === -1);
    let prepopOptions = _.concat(
      headerOptions,
      _.map(dpOptions, (member, index) => {
        return {
          key: index,
          value: index,
          text: `${member.firstName} ${member.lastName} (${
            member.emailAdr || member.userId
          })`,
        };
      })
    );

    const defaultDpLabel = isParticipants
      ? 'Add a participant'
      : isAors
      ? userAORorSAR
        ? 'Select the user being added as a SAR'
        : 'Select the user being added as an AOR'
      : 'Add a point of contact';

    const dpLabel = _.get(config, 'modal.dpLabel')
      ? _.get(config, 'modal.dpLabel')
      : defaultDpLabel;

    const defaultModalHeading = isParticipants
      ? 'Add application participant'
      : isAors
      ? userAORorSAR
        ? 'Add SAR'
        : 'Add AOR'
      : 'Add secondary point of contact';

    const modalEditHeading = _.get(config, 'modal.heading.edit')
      ? _.get(config, 'modal.heading.edit')
      : defaultModalHeading;

    const modalAddHeading = _.get(config, 'modal.heading.add')
      ? _.get(config, 'modal.heading.add')
      : defaultModalHeading;

    const modalHeading = contact && contact.email ? modalEditHeading : modalAddHeading;

    const defaultDpInstructions = isParticipants
      ? 'Add all individuals or organizations that assisted with this application.'
      : isAors
      ? ''
      : 'Enter a secondary point of contact for this application.';
    const dpInstructions = _.get(config, 'modal.dpInstructions')
      ? _.get(config, 'modal.dpInstructions')
      : defaultDpInstructions;

    const showMailingAddress = isParticipants || _.get(config, 'showMailingAddress');

    const duplicateEmailError = isPointOfContacts
      ? duplicatePointOfContactErrors
        ? duplicatePointOfContactErrors
        : {}
      : {}; // TODO, really needs to be moved into validation errors in config

    const displayErr = (fieldName) => {
      return displayObjectErrors(validationErrors, validationDirtyMap, fieldName);
    };

    return (
      open && (
        <FemaGoModal
          title={modalHeading}
          open={open}
          type={type}
          confirmButton={isAors ? true : 'hidden'}
          buttonText={userAORorSAR ? 'Add this SAR' : 'Add this AOR'}
          confirmAction={() => {
            if (userAORorSAR && selectedContact === -1) {
              handleDelete();
            } else {
              handleClose();
            }
            // this resets selectedContact after confirming
            this.setState({
              selectedContact: -1,
            });
          }}
          cancelAction={isAors ? handleDelete : handleClose}
          cancelButtonText={isAors ? 'Cancel' : 'Close'}
          size="large"
        >
          <p>{dpInstructions}</p>
          <Form>
            <br />
            <InlineSelect
              placeholder="-select-"
              id="participants"
              search
              selection
              label={dpLabel}
              name="participants"
              ariaLabelledBy="addUserContent"
              // value={-2}
              options={prepopOptions}
              handleChange={(event) => {
                this.handleChoosingUser(_.toNumber(event.target.value));
              }}
            />

            {type !== 'aors' && type !== 'sars' && (
              <React.Fragment>
                <br />
                {type === 'pointOfContacts' ? (
                  <div>
                    <InlineTextBoxField
                      id="Title"
                      title="Title"
                      label="Title"
                      name="title"
                      size="large"
                      value={_.get(contact, 'title', '')}
                      maxLength={31}
                      handleChange={(event) => {
                        this.handleChange('title', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('title')}
                      displayError={displayErr('title').displayError}
                      errorMessages={displayErr('title').errorMessages}
                    />
                    <Grid>
                      <Grid.Column width={3}>
                        <InlineSelect
                          placeholder="Prefix"
                          optional={true}
                          id="Prefix"
                          label="Prefix"
                          search
                          selection
                          title="Prefix"
                          name="prefix"
                          value={_.get(contact, 'prefix', '')}
                          options={salutationOpts}
                          handleChange={(event) => {
                            this.handleChange('prefix', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('prefix')}
                          displayError={displayErr('prefix').displayError}
                          errorMessages={displayErr('prefix').errorMessages}
                        />
                      </Grid.Column>
                    </Grid>
                  </div>
                ) : (
                  ''
                )}
                <Grid>
                  <Grid.Column width={8}>
                    <InlineTextBoxField
                      id="firstName"
                      title="First name"
                      label="First name"
                      name="firstName"
                      value={_.get(contact, 'firstName', '')}
                      maxLength={81}
                      handleChange={(event) => {
                        this.handleChange('firstName', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('firstName')}
                      displayError={displayErr('firstName').displayError}
                      errorMessages={displayErr('firstName').errorMessages}
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <InlineTextBoxField
                      title="Middle initial"
                      label="Middle initial"
                      name="middleInitial"
                      value={_.get(contact, 'middleInitial', '')}
                      optional={true}
                      style={{width: '10px'}}
                      maxLength={1}
                      handleChange={(event) => {
                        this.handleChange('middleInitial', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('middleInitial')}
                      displayError={displayErr('middleInitial').displayError}
                      errorMessages={displayErr('middleInitial').errorMessages}
                    />
                  </Grid.Column>
                </Grid>

                <br />
                <Grid>
                  <Grid.Column width={8}>
                    <InlineTextBoxField
                      id="lastName"
                      title="Last name"
                      label="Last name"
                      name="lastName"
                      value={_.get(contact, 'lastName', '')}
                      maxLength={81}
                      handleChange={(event) => {
                        this.handleChange('lastName', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('lastName')}
                      displayError={displayErr('lastName').displayError}
                      errorMessages={displayErr('lastName').errorMessages}
                    />
                  </Grid.Column>
                </Grid>
                <Grid>
                  <Grid.Column width={8}>
                    <InlineTextBoxField
                      id="primaryPhone"
                      title="Primary phone"
                      label="Primary phone"
                      name="phoneNumber"
                      value={_.get(contact, 'phoneNumber', '')}
                      maxLength={11}
                      handleChange={(event) => {
                        this.handleChange('phoneNumber', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('phoneNumber')}
                      displayError={displayErr('phoneNumber').displayError}
                      errorMessages={displayErr('phoneNumber').errorMessages}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <InlineTextBoxField
                      title="Ext"
                      label="Ext"
                      name="extension"
                      value={_.get(contact, 'extension', '')}
                      optional={true}
                      maxLength={7}
                      handleChange={(event) => {
                        this.handleChange('extension', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('extension')}
                      displayError={displayErr('extension').displayError}
                      errorMessages={displayErr('extension').errorMessages}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <InlineSelect
                      placeholder="Type"
                      id="Phone0Type"
                      label="Type"
                      search
                      selection
                      title="Phone0Type"
                      name="Phone0Type"
                      value={_.get(contact, 'phoneNumberType', '')}
                      options={phoneNumberOptions}
                      handleChange={(event) => {
                        this.handleChange('phoneNumberType', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('phoneNumberType')}
                      displayError={displayErr('phoneNumberType').displayError}
                      errorMessages={displayErr('phoneNumberType').errorMessages}
                    />
                  </Grid.Column>
                </Grid>

                {type === 'pointOfContacts' ? (
                  <div>
                    <Grid>
                      <Grid.Column width={8}>
                        <InlineTextBoxField
                          id="secondaryPhone"
                          title="Secondary phone"
                          label="Secondary phone"
                          name="secondaryPhoneNumber"
                          value={_.get(contact, 'secondaryPhoneNumber', '')}
                          maxLength={11}
                          handleChange={(event) => {
                            this.handleChange('secondaryPhoneNumber', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('secondaryPhoneNumber')}
                          displayError={displayErr('secondaryPhoneNumber').displayError}
                          errorMessages={displayErr('secondaryPhoneNumber').errorMessages}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <InlineTextBoxField
                          title="Ext"
                          label="Ext"
                          name="secondaryPhoneExt"
                          value={_.get(contact, 'secondaryPhoneExt', '')}
                          optional={true}
                          maxLength={7}
                          handleChange={(event) => {
                            this.handleChange('secondaryPhoneExt', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('secondaryPhoneExt')}
                          displayError={displayErr('secondaryPhoneExt').displayError}
                          errorMessages={displayErr('secondaryPhoneExt').errorMessages}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <InlineSelect
                          placeholder="Type"
                          id="Type"
                          label="Type"
                          search
                          selection
                          title="Type"
                          name="secondaryPhoneType"
                          value={_.get(contact, 'secondaryPhoneType', '')}
                          options={phoneNumberOptions}
                          handleChange={(event) => {
                            this.handleChange('secondaryPhoneType', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('secondaryPhoneType')}
                          displayError={displayErr('secondaryPhoneType').displayError}
                          errorMessages={displayErr('secondaryPhoneType').errorMessages}
                        />
                      </Grid.Column>
                    </Grid>

                    <Grid>
                      <Grid.Column width={8}>
                        <InlineTextBoxField
                          title="Optional phone"
                          label="Optional phone"
                          name="optionalPhoneNumber"
                          value={_.get(contact, 'optionalPhoneNumber', '')}
                          optional={true}
                          maxLength={11}
                          handleChange={(event) => {
                            this.handleChange('optionalPhoneNumber', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('optionalPhoneNumber')}
                          displayError={displayErr('optionalPhoneNumber').displayError}
                          errorMessages={displayErr('optionalPhoneNumber').errorMessages}
                        />
                      </Grid.Column>
                      {!!_.get(contact, 'optionalPhoneNumber') && [
                        <Grid.Column width={4}>
                          <InlineTextBoxField
                            title="Ext"
                            label="Ext"
                            name="optionalPhoneExt"
                            value={_.get(contact, 'optionalPhoneExt', '')}
                            optional={true}
                            maxLength={7}
                            handleChange={(event) => {
                              this.handleChange('optionalPhoneExt', event.target.value);
                            }}
                            handleBlur={() => this.saveContactInfo('optionalPhoneExt')}
                            displayError={displayErr('optionalPhoneExt').displayError}
                            errorMessages={displayErr('optionalPhoneExt').errorMessages}
                          />
                        </Grid.Column>,
                        <Grid.Column width={4}>
                          <InlineSelect
                            placeholder="Type"
                            id="Type"
                            label="Type"
                            search
                            selection
                            title="Type"
                            name="optionalPhoneType"
                            value={_.get(contact, 'optionalPhoneType', '')}
                            options={phoneNumberOptions}
                            handleChange={(event) => {
                              this.handleChange('optionalPhoneType', event.target.value);
                            }}
                            handleBlur={() => this.saveContactInfo('optionalPhoneType')}
                            displayError={displayErr('optionalPhoneType').displayError}
                            errorMessages={displayErr('optionalPhoneType').errorMessages}
                          />
                        </Grid.Column>,
                      ]}
                    </Grid>

                    <Grid>
                      <Grid.Column width={8}>
                        <InlineTextBoxField
                          title="Fax number"
                          label="Fax number"
                          name="fax"
                          value={_.get(contact, 'fax', '')}
                          optional={true}
                          maxLength={11}
                          handleChange={(event) => {
                            this.handleChange('fax', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('fax')}
                          displayError={displayErr('fax').displayError}
                          errorMessages={displayErr('fax').errorMessages}
                        />
                      </Grid.Column>
                    </Grid>
                  </div>
                ) : (
                  ''
                )}
                <Grid>
                  <Grid.Column width={12}>
                    <InlineTextBoxField
                      id="email"
                      title="Email"
                      label="Email"
                      name="email"
                      value={_.get(contact, 'email', '')}
                      maxLength={101}
                      handleChange={(event) => {
                        this.handleChange('email', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('email')}
                      displayError={
                        displayErr('email').displayError ||
                        duplicateEmailError.isValid === false // TODO, this duplciateEmailError stuff should get moved ot config
                      }
                      errorMessages={
                        displayErr('email').errorMessages || duplicateEmailError.message
                      }
                    />
                  </Grid.Column>
                </Grid>

                {showMailingAddress ? (
                  <div>
                    <br />
                    <Header as="h4">Add mailing address</Header>
                    <hr />

                    <InlineTextBoxField
                      id="addressLine1"
                      title="Address line 1"
                      label="Address line 1"
                      name="mailingAddress.address1"
                      size="large"
                      value={_.get(contact, 'mailingAddress.address1', '')}
                      maxLength={81}
                      handleChange={(event) => {
                        this.handleChange('mailingAddress.address1', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('mailingAddress.address1')}
                      displayError={displayErr('mailingAddress.address1').displayError}
                      errorMessages={displayErr('mailingAddress.address1').errorMessages}
                    />

                    <InlineTextBoxField
                      title="Address line 2"
                      label="Address line 2"
                      optional={true}
                      size="large"
                      name="mailingAddress.address2"
                      value={_.get(contact, 'mailingAddress.address2', '')}
                      maxLength={81}
                      handleChange={(event) => {
                        this.handleChange('mailingAddress.address2', event.target.value);
                      }}
                      handleBlur={() => this.saveContactInfo('mailingAddress.address2')}
                      displayError={displayErr('mailingAddress.address2').displayError}
                      errorMessages={displayErr('mailingAddress.address2').errorMessages}
                    />

                    <Grid>
                      <Grid.Column width={8}>
                        <InlineTextBoxField
                          id="City"
                          title="City"
                          label="City"
                          name="mailingAddress.city"
                          width={80}
                          value={_.get(contact, 'mailingAddress.city', '')}
                          maxLength={81}
                          handleChange={(event) => {
                            this.handleChange('mailingAddress.city', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('mailingAddress.city')}
                          displayError={displayErr('mailingAddress.city').displayError}
                          errorMessages={displayErr('mailingAddress.city').errorMessages}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <InlineSelect
                          placeholder="State"
                          id="State"
                          label="State/territory"
                          search
                          selection
                          title="State"
                          name="mailingAddress.state"
                          value={_.get(contact, 'mailingAddress.state')}
                          options={STATE_OPTIONS}
                          handleChange={(event) => {
                            this.handleChange('mailingAddress.state', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('mailingAddress.state')}
                          displayError={displayErr('mailingAddress.state').displayError}
                          errorMessages={displayErr('mailingAddress.state').errorMessages}
                        />
                      </Grid.Column>
                    </Grid>

                    <Grid>
                      <Grid.Column width={4}>
                        <InlineTextBoxField
                          id="zipCode"
                          title="Zip code"
                          label="Zip code"
                          name="mailingAddress.zip"
                          value={_.get(contact, 'mailingAddress.zip', '')}
                          maxLength={5}
                          handleChange={(event) => {
                            this.handleChange('mailingAddress.zip', event.target.value);
                          }}
                          handleBlur={() => this.saveContactInfo('mailingAddress.zip')}
                          displayError={displayErr('mailingAddress.zip').displayError}
                          errorMessages={displayErr('mailingAddress.zip').errorMessages}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <InlineTextBoxField
                          title="Zip extension"
                          label="Zip extension"
                          name="mailingAddress.zipExt"
                          value={_.get(contact, 'mailingAddress.zipExt', '')}
                          style={{width: '10px'}}
                          maxLength={4}
                          optional={true}
                          handleChange={(event) => {
                            this.handleChange(
                              'mailingAddress.zipExt',
                              event.target.value
                            );
                          }}
                          handleBlur={() => this.saveContactInfo('mailingAddress.zipExt')}
                          displayError={displayErr('mailingAddress.zipExt').displayError}
                          errorMessages={
                            displayErr('mailingAddress.zipExt').errorMessages
                          }
                        />
                      </Grid.Column>
                    </Grid>
                  </div>
                ) : (
                  ''
                )}
              </React.Fragment>
            )}
            {(type === 'aors' || type === 'sars') && (
              <React.Fragment>
                <input
                  type="hidden"
                  name="firstName"
                  value={_.get(contact, 'firstName', '')}
                />
                <input
                  type="hidden"
                  name="lastName"
                  value={_.get(contact, 'lastName', '')}
                />
                <input type="hidden" name="email" value={_.get(contact, 'email', '')} />
                {contact && contact.email && (
                  <Alert
                    id="addUserContent"
                    size="medium"
                    header=""
                    htmlContent={
                      userAORorSAR
                        ? `Is this the person you want to add as an SAR?<p>${contact.firstName} ${contact.lastName} (${contact.email})</p>`
                        : `Is this the person you want to add as an AOR?<p>${contact.firstName} ${contact.lastName} (${contact.email})</p>`
                    }
                    type="info"
                    dismissable={false}
                  />
                )}
              </React.Fragment>
            )}
          </Form>
        </FemaGoModal>
      )
    );
  }
}

const getEntitiesInfo = (userEntitiesInfo) => {
  const canHaveSuborganizations =
    _.findIndex(userEntitiesInfo, 'canHaveSuborganizations') >= 0;
  return canHaveSuborganizations;
};
export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
    canHaveSubOrg: getEntitiesInfo(state.userEntities.entitiesData),
  };
};
export default connect(mapStateToProps, null)(ContactInfoModal);
